/* Built In Imports */
import { useContext } from 'react';

/* External Imports */
/* Internal Imports */
/* Components */
import WisdomBlog from '@components/WisdomBlog';
import config from '@config';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData
} from 'services/commonService';
import {
  fetchAllTopicsList, fetchBlogLandingPageData,
  getWisdomLandingPaths
} from 'services/wisdomService';

/**
 * Renders the Blog Landing Page
 *
 * @function
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} headerMenuData - Header Menu Options
 * @param {string} pageData - Blog Landing Page Data
 * @param {string} blogTopics - Blog Topics for Wisdom Filter
 * @param {string} footerData - Page Footer Data
 * @param {string} page - Page Name
 * @returns {ReactElement} Blog Landing Page
 */
export default function BlogLandingPage({
  region,
  language,
  headerMenuData,
  pageData,
  blogTopics,
  footerData,
  page
}) {
  const authContext = useContext(AuthContext);
  // console.log('BlogLandingPage.region', authContext.region, authContext.lang, region);

  return pageData?.posts?.cards?.length > 0 ? (
    <WisdomBlog
      headerMenuData={headerMenuData}
      pageData={pageData}
      reg={authContext.region}
      lang={authContext.lang}
      footerData={footerData}
      section={page}
      wisdomTopics={blogTopics}
      urlpath={`/${authContext.lang}/blog`}
    ></WisdomBlog>
  ) : null;
}

export const getStaticPaths = async () => {
  const wisdomLandingPaths = config.USE_LOCAL_URL
    ? ['/en/blog', '/gu/blog']
    : await getWisdomLandingPaths('lvl0', '/blog');
  return {
    paths: wisdomLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region },
  req,
}) => {
  const language = region;

  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale('', language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language),
    'iso_non_regional_menu'
  );
  const footerData = await fetchFooterData(
    getLocale('', language),
    'isofooter'
  );
  const pageData = await fetchBlogLandingPageData('', language, 'blog', {
    preview,
    data: previewData
  });
  const topics = await fetchAllTopicsList('', language);

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: '',
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      blogTopics: topics?.topics || null,
      page: 'Blog',
      isPreview: preview ? true : false
    }
  };
};
